<template>
  <div class="UseCard">
    <div class="pages">
      <div class="card-head">
        <div class="left">
          <img :src="res.img" alt />
        </div>
        <div class="right flex-1">
          <p class="text">{{res.title}}</p>
          <!-- <div class="right-bottom">
            <span>
              总价：
              <span class="orange">￥100.00</span>
            </span>
            <van-button @click="handleRebate">退款</van-button>
          </div>-->
        </div>
      </div>
    </div>
    <div class="card pages pad">
      <ul class="orders">
        <li>
          <span class="label">退款金额:</span>
          <span class="text orange">￥{{res.price|priceFilter}}</span>
        </li>
        <li>
          <span class="label">退款时间:</span>
          <span class="text">{{curruntTime}}</span>
        </li>
      </ul>
    </div>
    <!-- 交易信息 -->
    <div class="card pages last-page">
      <p class="grey">退款理由:</p>
      <van-radio-group v-model="radioId">
        <van-cell-group>
          <van-cell clickable @click="checkRadio(v)" v-for="v in fundList" :key="v.id">
            <div slot="title" class="left-cell">
              <van-radio slot="right-icon" :name="v.id" />
              <span>{{v.name}}</span>
            </div>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <van-button type="primary" class="large-button" @click="getSubmit">提交</van-button>
  </div>
</template>

<script>
export default {
  name: "Refund",
  components: {},
  data () {
    return {
      bShowGuide: false, // 弹窗
      fundList: [
        { id: 1, name: "计划有变" },
        { id: 2, name: "购买错误" },
        { id: 3, name: "不想要了" },
        { id: 4, name: "发票问题" }
      ],
      radioId: 1,
      curruntTime: this.dateFormat(new Date().getTime(), "yyyy-MM-dd hh:mm:ss"),
      query: {},
      res: {}
    };
  },
  computed: {},
  mounted () {
    this.query = this.getQuery(this);
    if (this.query.id) {
      this.getDetail();
    }
  },
  methods: {
    // 提交表单
    async getSubmit () {
      // user/userOrder/refund
      // if (this.getItemByKeyVal(this.fundList, this.radioId, "id").name) {
      //   console.log(
      //     this.getItemByKeyVal(this.fundList, this.radioId, "id").name
      //   );
      //   return;
      // }
      let res = await this.request("/user/userOrder/refund", {
        id: this.query.id,
        refundReason: this.getItemByKeyVal(this.fundList, this.radioId, "id")
          .name
      });
      if (res.code === 0) {
        this.$dialog
          .alert({
            title: "提交成功",
            confirmButtonText: "好的",
            message: "系统会尽快为您安排退款事项,请耐心等待～"
          })
          .then(() => {
            // on close
            this.goBack();
          });
      } else if (res.code === -1) {
        this.$dialog
          .alert({
            title: "提交失败",
            confirmButtonText: "好的",
            message: "券码已在预约中，不能申请退款"
          })
          .then(() => {
            // on close
            this.goBack();
          });
      }
    },
    // 选择理由
    checkRadio (v) {
      this.radioId = v.id;
    },
    // user/userOrder/get
    async getDetail () {
      let res = await this.request("/user/userOrder/get", {
        id: this.query.id
      });
      if (res.code === 0) {
        // console.log(res);
        this.res = { ...res.data };
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
.van-cell:not(:last-child)::after {
  border: 0;
}
.pad {
  border-top: 10px solid #f7f7f7;
  border-bottom: 10px solid #f7f7f7;
}
.UseCard {
  background: #fff;
  height: 100vh;
  overflow: auto;
  .pages {
    background: #fff;
    padding: @pad;

    &.last-page {
      margin-bottom: 0;
    }
  }
  .grey {
    color: #585858;
  }
  .orange {
    color: #ff8939;
  }
  .ellis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
  }
  .title {
    font-size: 15px;
    font-weight: bold;
    color: #333;
  }
  .in-title {
    .flex-center();
    justify-content: flex-start;
    i {
      display: inline-block;
      width: 3px;
      height: 12px;
      background: #3296fa;
      margin-right: 5px;
    }
    span {
      font-size: 15px;
      font-weight: bold;
      color: #333;
    }
  }
  .card-head {
    .flex-center();
    align-items: flex-start;
    .sc(15px, #333);
    .left {
      width: 80px;
      margin-right: @pad;
      img {
        width: 100%;
        border-radius: 3px;
      }
    }
    .right {
      .text {
        font-size: 14px;
      }
    }
  }
  .last-page {
    font-size: 14px;
  }
  .left-cell {
    .flex-center();
    justify-content: flex-start;
    span {
      padding-left: 10px;
      font-size: 13px;
    }
  }
  .orders {
    li {
      line-height: 35px;
      .label {
        width: 80px;
        display: inline-block;
      }
      .sc(14px, #585858);
    }
  }
  .large-button {
    width: 80%;
    display: block;
    margin: 100px auto 15px auto;
  }
}
</style>